import React from "react";

export default function DomainSalePage() {
  const domain = "www.attire.pk";
  const email = "attire.com.pk@gmail.com";

  return (
   <div style={styles.container}>
  <div style={styles.card}>
    <h1 style={styles.domain}>{domain}</h1>
    <p style={styles.tagline}>This domain is for sale</p>

    <div style={styles.priceBox}>
      <a href={`mailto:${email}`} style={styles.price}>
        {email}
      </a>
    </div>

    {/* <p style={styles.note}>
      Contact via email only. Serious inquiries only.
    </p> */}
  </div>
</div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #0f172a, #1e293b)",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    background: "#111827",
    padding: "40px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
    maxWidth: "400px",
    width: "90%",
  },
  domain: {
    fontSize: "2.5rem",
    marginBottom: "10px",
  },
  tagline: {
    fontSize: "1.2rem",
    marginBottom: "20px",
    color: "#9ca3af",
  },
  priceBox: {
    margin: "20px 0",
  },
  price: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#22c55e",
  },
  button: {
    background: "#22c55e",
    border: "none",
    padding: "12px 24px",
    fontSize: "1rem",
    borderRadius: "8px",
    cursor: "pointer",
    color: "#000",
    fontWeight: "bold",
  },
  note: {
    marginTop: "15px",
    fontSize: "0.9rem",
    color: "#6b7280",
  },
};